import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import COALibrary from "./pages/coa/COALibrary";
import CreateCOA from "./pages/coa/CreateCOA";
import CreateThirdPartyCOA from "./pages/coa/CreateThirdPartyCOA";
import COAPreview from "./pages/coa/COAPreview";
import ThirdPartyCOALibrary from "./pages/coa/ThirdPartyCOALibrary";
import RequestedLicences from "./pages/licences/RequestedLicences";
import LicenceDetails from "./pages/licences/LicenceDetails";
import EditLicence from "./pages/licences/EditLicence";
import EditLicenseRequest from "./pages/licences/EditLicenseRequest";
import MyReviewQueue from "./pages/licences/MyReviewQueue";
import MyApprovalQueue from "./pages/licences/MyApprovalQueue";
import Customers from "./pages/customers/Customers";
import CustomerDetails from "./pages/customers/CustomerDetails";
import Transactions from "./pages/transactions/Transactions";
import PersonalDetails from "./pages/settings/PersonalDetails";
import Notifications from "./pages/settings/Notifications";
import RolesPermissions from "./pages/settings/RolesPermissions";
import XeroSettings from "./pages/settings/XeroSettings";
import RoleDetails from "./pages/settings/RoleDetails";
import Invoices from "./pages/invoices/Invoices";
import InvoiceDetails from "./pages/invoices/InvoiceDetails";
import AdminTeam from "./pages/settings/AdminTeam";
import TeamMemberDetails from "./pages/settings/TeamMemberDetails";
import NotificationList from "./pages/notifications/NotificationList";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ErrorBoundary from "./components/ui/ErrorBoundary";
import Quotation from "./pages/quotations/Quotation";
import EditQuotation from "./pages/quotations/EditQuotation";
import MessagesPage from "./pages/messages/MessagesPage";
import VerifyEmail from "./pages/auth/VerifyEmail";
import CMS from "./pages/cms/CMS";
import TranslationRequestDetails from "./pages/licences/TranslationRequestDetails";

function App() {
  return (
    <ErrorBoundary>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#40C191',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#F87171',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        {/* Login Route - No Layout - Default */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* Protected Routes with Layout */}
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/coa-library"
          element={
            <Layout>
              <COALibrary />
            </Layout>
          }
        />
        <Route
          path="/third-party-coas"
          element={
            <Layout>
              <ThirdPartyCOALibrary />
            </Layout>
          }
        />
        <Route
          path="/create-coa"
          element={
            <Layout>
              <CreateCOA />
            </Layout>
          }
        />
        <Route
          path="/create-coa/:id"
          element={
            <Layout>
              <CreateCOA />
            </Layout>
          }
        />
        <Route
          path="/create-third-party-coa"
          element={
            <Layout>
              <CreateThirdPartyCOA />
            </Layout>
          }
        />
        <Route
          path="/create-third-party-coa/:id"
          element={
            <Layout>
              <CreateThirdPartyCOA />
            </Layout>
          }
        />
        {/* <Route
          path="/coa-preview"
          element={
            <Layout>
              <COAPreview />
            </Layout>
          }
        /> */}
        <Route
          path="/coa-preview/:id"
          element={
            <Layout>
              <COAPreview />
            </Layout>
          }
        />
        <Route
          path="/requested-licences"
          element={
            <Layout>
              <RequestedLicences />
            </Layout>
          }
        />
        <Route
          path="/licences/:id"
          element={
            <Layout>
              <LicenceDetails />
            </Layout>
          }
        />
        <Route
          path="/licence-details/:id"
          element={
            <Layout>
              <LicenceDetails />
            </Layout>
          }
        />
        <Route
          path="/translation-request/:id"
          element={
            <Layout>
              <TranslationRequestDetails />
            </Layout>
          }
        />
        <Route
          path="/my-review-queue"
          element={
            <Layout>
              <MyReviewQueue />
            </Layout>
          }
        />
        <Route
          path="/my-approval-queue"
          element={
            <Layout>
              <MyApprovalQueue />
            </Layout>
          }
        />
        <Route
          path="/edit-licence/:id"
          element={
            <Layout>
              <EditLicence />
            </Layout>
          }
        />
        <Route
          path="/edit-license-request/:id"
          element={
            <Layout>
              <EditLicenseRequest />
            </Layout>
          }
        />
        <Route
          path="/customers"
          element={
            <Layout>
              <Customers />
            </Layout>
          }
        />
        <Route
          path="/customer-details/:id"
          element={
            <Layout>
              <CustomerDetails />
            </Layout>
          }
        />
        <Route
          path="/quotations"
          element={
            <Layout>
              <Quotation />
            </Layout>
          }
        />
        <Route
          path="/quotations/:id"
          element={
            <Layout>
              <Quotation />
            </Layout>
          }
        />
        <Route
          path="/edit-quotation/:id"
          element={
            <Layout>
              <EditQuotation />
            </Layout>
          }
        />
        <Route
          path="/messages"
          element={
            <Layout>
              <MessagesPage />
            </Layout>
          }
        />
        <Route
          path="/cms"
          element={
            <Layout>
              <CMS />
            </Layout>
          }
        />
        <Route
          path="/transactions"
          element={
            <Layout>
              <Transactions />
            </Layout>
          }
        />
        <Route
          path="/settings/personal-details"
          element={
            <Layout>
              <PersonalDetails />
            </Layout>
          }
        />
        <Route
          path="/settings/notifications"
          element={
            <Layout>
              <Notifications />
            </Layout>
          }
        />
        <Route
          path="/settings/xero"
          element={
            <Layout>
              <XeroSettings />
            </Layout>
          }
        />
        <Route
          path="/invoices"
          element={
            <Layout>
              <Invoices />
            </Layout>
          }
        />
        <Route
          path="/invoices/:id"
          element={
            <Layout>
              <InvoiceDetails />
            </Layout>
          }
        />
        <Route
          path="/settings/roles-permissions"
          element={
            <Layout>
              <RolesPermissions />
            </Layout>
          }
        />
        <Route
          path="/settings/role-details/:id"
          element={
            <Layout>
              <RoleDetails />
            </Layout>
          }
        />
        <Route
          path="/settings/admin-team"
          element={
            <Layout>
              <AdminTeam />
            </Layout>
          }
        />
        <Route
          path="/settings/team-member/:id"
          element={
            <Layout>
              <TeamMemberDetails />
            </Layout>
          }
        />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
